module.exports = __webpack_public_path__ + "img/icon_fk_take_effect.cfa5b52f.png";